import { render, staticRenderFns } from "./topicList.vue?vue&type=template&id=9c9a2320&scoped=true&"
import script from "./topicList.vue?vue&type=script&lang=js&"
export * from "./topicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9a2320",
  null
  
)

export default component.exports